"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../../assets/css/components/structure/content.css");

var _Breadcrumb = require("./Breadcrumb");

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _DetachedToolbar = require("./Tab/DetachedToolbar");

var _DetachedToolbar2 = _interopRequireDefault(_DetachedToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Conteudo = function (_React$Component) {
    _inherits(Conteudo, _React$Component);

    function Conteudo(props) {
        _classCallCheck(this, Conteudo);

        var _this = _possibleConstructorReturn(this, (Conteudo.__proto__ || Object.getPrototypeOf(Conteudo)).call(this, props));

        _this.getBreadCrumb = function () {
            if (_this.props.location.pathname !== '/') return _react2.default.createElement(_Breadcrumb2.default, { name: "Home", className: "mdl-cell mdl-cell--12-col", routes: _this.props.routes, params: _this.props.params, separator: " / ",
                displayMissing: true });
        };

        _this.state = {
            toolbarAlign: _this.props.toolbarAlign || 'left',
            floatToolbar: _this.props.floatToolbar || false,
            displayRightNav: false
        };
        return _this;
    }

    _createClass(Conteudo, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                toolbarAlign: this.props.toolbarAlign || 'left',
                floatToolbar: nextProps.floatToolbar,
                displayRightNav: nextProps.displayRightNav
            });
        }
    }, {
        key: "getToobar",
        value: function getToobar() {
            if (this.props.toolbar) return _react2.default.createElement(
                "div",
                { className: "mdl-cell mdl-cell--3-col mdl-cell--order-" + (this.state.toolbarAlign === 'left' ? 1 : 2) + (this.state.floatToolbar ? " toolbar mtd-float-toolbar" : " toolbar") + (this.state.displayRightNav ? " displayNav" : "") },
                _react2.default.createElement(_DetachedToolbar2.default, { toolbar: this.props.toolbar, closeNav: this.props.closeRightNav })
            );
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "main",
                { className: "mdl-layout__content" },
                _react2.default.createElement(
                    "div",
                    { className: "row mdl-grid mdl-grid--no-spacing" },
                    this.getBreadCrumb(),
                    this.getToobar(),
                    _react2.default.createElement(
                        "div",
                        { className: "main-content mdl-cell mdl-cell--" + (this.props.toolbar ? 9 : 12) + "-col mdl-cell--order-" + (this.state.toolbarAlign === 'left' ? 2 : 1) },
                        this.props.children
                    )
                )
            );
        }
    }]);

    return Conteudo;
}(_react2.default.Component);

exports.default = Conteudo;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/structure/Content.js
// module id = 592
// module chunks = 0